import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from '@emotion/styled'
import { DESKTOP_BREAKPOINT, SmallP, Link } from '@xfers/design-system'
import { ConfigManager } from '~/managers/ConfigManager'

enum ADVISORY_TYPE {
  DEFAULT = 'default',
  EARN = 'earn',
}

const XSGDAdvisory = () => {
  const DefaultAdvisory = (
    <Advisory>
      <p>XSGD and XIDR are issued by StraitsX.</p>
      <p>StraitsX is a trademark of Xfers Pte Ltd.</p>
      <p>
        StraitsX is the trading name of Xfers Pte Ltd, which is the holder of a Major Payment
        Institution license for e-money issuance under the Payment Services Act.
      </p>
      <br></br>
      <b>RISK WARNING ON DIGITAL PAYMENT TOKEN SERVICES</b>
      <p>
        The Monetary Authority of Singapore (MAS) requires us to provide this risk warning to you as
        a customer of a digital payment token (DPT) service provider.
      </p>
      <p>
        Before you pay your DPT service provider any money or DPT, you should be aware of the
        following.
      </p>
      <FooterNumber type="1">
        <li>
          Your DPT service provider is exempted by MAS from holding a licence to provide DPT
          services. Please note that you may not be able to recover all the money or DPTs you paid
          to your DPT service provider if your DPT service provider’s business fails.
        </li>
        <li>
          You should not transact in the DPT if you are not familiar with this DPT. This includes
          how the DPT is created, and how the DPT you intend to transact is transferred or held by
          your DPT service provider.
        </li>
        <li>
          You should be aware that the value of DPTs may fluctuate greatly. You should buy DPTs only
          if you are prepared to accept the risk of losing all of the money you put into such
          tokens.
        </li>
        <li>
          You should be aware that your DPT service provider, as part of its licence to provide DPT
          services, may offer services related to DPTs which are promoted as having a stable value,
          commonly known as “stablecoin”.
        </li>
      </FooterNumber>
    </Advisory>
  )
  const EarnAdvisory = (
    <Advisory>
      <p>
        Consumer advisory - StraitsX Earn is a product offered by Xfers Invest Pte. Ltd. (”XIPL”),
        which is an affiliate of Xfers Pte. Ltd. XIPL is not licensed or regulated by the Monetary
        Authority of Singapore (”MAS”). MAS does not endorse StraitsX Earn or any other
        service/product offered by XIPL. StraitsX Earn is not a risk-free product. Funds can be lost
        due to risks associated with decentralised finance protocols, such as smart contract risks,
        protocol failures, hacks from malicious attackers and other similar risks. Users are advised
        to read our{' '}
        <Link
          size="small"
          href="https://www.straitsx.com/sg/earn-terms-of-service"
          rel="noopener noreferrer"
          target="_blank"
        >
          terms of service
        </Link>{' '}
        carefully.
      </p>
    </Advisory>
  )

  const history = useHistory()
  const currentPath = history.location.pathname

  const advisoryType = (() => {
    switch (currentPath) {
      case RegExp(/earn/).exec(currentPath)?.input:
        return ADVISORY_TYPE.EARN
      default:
        return ADVISORY_TYPE.DEFAULT
    }
  })()
  const SelectedAdvisory = (() => {
    switch (advisoryType) {
      case ADVISORY_TYPE.EARN:
        return EarnAdvisory
      default:
        return DefaultAdvisory
    }
  })()

  return SelectedAdvisory
}

const XIDRAdvisory = () => (
  <Advisory>
    <p>XSGD and XIDR are issued by StraitsX.</p>
    <p>StraitsX is a trademark of Xfers Pte Ltd.</p>
    <p>
      StraitsX is the trading name of Xfers Pte Ltd, which is the holder of a Major Payment
      Institution license for e-money issuance under the Payment Services Act.
    </p>
  </Advisory>
)

const Footer = () => (
  <FooterContainer>
    {ConfigManager.isXSGDSite() && <XSGDAdvisory />}
    {ConfigManager.isXIDRSite() && <XIDRAdvisory />}
  </FooterContainer>
)

export default Footer

const FooterContainer = styled(SmallP)`
  min-width: 100%;
  flex-grow: 1;
  color: #777777;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  ${DESKTOP_BREAKPOINT} {
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 24px;
  }
`

const Advisory = styled(SmallP)`
  font-size: 12px;
  line-height: 18px;
  color: #777777;
`

const FooterNumber = styled.ol`
  max-width: 80%;
  padding-left: 20px;
  text-align: justify;
`
